import axios from "axios";
const APISERVER = "https://zadsystem.khzad.org/api/v1/";
const localPath="https://attendance.test/api/"
export const api = axios.create({
  // baseURL:"https://back_zad-main.test/api/v1/",
  baseURL: APISERVER,
  withCredentials: true,
});

export const loginApi = axios.create({
  // baseURL:"https://back_zad-main.test/api/v1/",
  baseURL: APISERVER,
  withCredentials: true,
});


export const localApi=axios.create({
  baseURL: localPath,
  withCredentials: true,
});